export default "__VITE_PUBLIC_ASSET__acddd691__"